import { render } from "./GlobalBreadcrumb.vue?vue&type=template&id=8415c4a0"
import script from "./GlobalBreadcrumb.vue?vue&type=script&lang=js"
export * from "./GlobalBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__